<!--
  ServerErrorView.vue — the '/server-error' page (route name `server-error`).
  Purpose: the landing page the request layer pushes to on backend status.code 12
  (which also commits the root `service_error` mutation). Kept intentionally tiny.
  Reconstructed from lacak.io deployed behavior; app-specific contract verbatim
  (status.code 12 -> commit service_error + push '/server-error' — AUTH-SESSION §2.3),
  internal impl re-authored.
-->
<template>
  <v-container fill-height class="tracko-center">
    <div class="text-xs-center">
      <div class="display-2 tracko-muted mb-3">Server error</div>
      <div class="tracko-muted mb-4">The service returned an unexpected error (status 12).</div>
      <v-btn color="primary" :to="{ name: 'root' }">Back to monitoring</v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'ServerErrorView'
}
</script>
